// extracted by mini-css-extract-plugin
export default {"tablecontainer":"Alerts_tablecontainer__UEyZ-","tablemain":"Alerts_tablemain__E+yaH","loader-div":"Alerts_loader-div__abyF0"};